const features = [
  {
    icon: 'ri-table-line',
    title: 'Structured Data',
    description:
      'The acbuy spreadsheet organizes product information in a clean, structured format that makes comparison effortless. No more jumping between dozens of browser tabs.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Price Tracking',
    description:
      'Monitor price changes across categories in real time. The acbuyspreadsheet system helps you spot deals before they disappear and track trends over time.',
  },
  {
    icon: 'ri-radar-line',
    title: 'Trend Alerts',
    description:
      'Stay ahead of the curve with trending product alerts. The acbuy spreadsheet highlights emerging items so you never miss what is gaining popularity.',
  },
  {
    icon: 'ri-filter-3-line',
    title: 'Smart Filtering',
    description:
      'Filter by category, price range, and rating with a few clicks. The acbuy spreadsheet makes product discovery fast and intuitive for every type of shopper.',
  },
  {
    icon: 'ri-time-line',
    title: 'Save Research Time',
    description:
      'Cut your product research time by over 70%. Instead of manually browsing, let the acbuy spreadsheet system surface the best options for you.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Transparent Reviews',
    description:
      'Every product listed in the acbuy spreadsheet includes transparent comparison data so you can make informed decisions without hidden biases.',
  },
];

export default function FeatureGrid() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <p className="text-xs font-semibold tracking-widest text-secondary-600 uppercase mb-4">
            Why ACBuy Spreadsheet
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight max-w-2xl">
            Compare Faster, <br />Shop Smarter
          </h2>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-2xl p-8 border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-background-50 flex items-center justify-center mb-6 group-hover:bg-primary-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-foreground-800 group-hover:text-primary-600 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}